import Styled from 'styled-components';

const AttachmentFieldContainer = Styled.div`
  display: flex;
  flex-flow: row wrap;
  & .attachment-text {
    flex: 1;
  }
  & .add-attachment {
    margin: 10px;
  }
`;

const AttachmentList = Styled.ul`
  background: #fefefe;
`;

const AttachmentItem = Styled.div`
  background: #fefefe;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 20px 0;
  & .attachment-file-icon {
    flex: 0 1 40px;
    height: 35px;
  }
  & .attachment-filename {
    flex: 1;
    margin: 0;
  }
`;

export { AttachmentFieldContainer, AttachmentList, AttachmentItem };
